<template>
	<div class="flex flex-col">
		<app-title-bar :icon="['fab', 'mailchimp']" title="Marketing Lists" subtitle="Mailchimp">
			<app-button icon="fa-circle-info" theme="warning" @click="help = true">
				Help
			</app-button>
		</app-title-bar>

		<!-- Post-upload summary -->
		<app-panel v-if="upload" title="Upload Summary">
			{{ upload.message }}
			<!--<list-upload-summary :upload="upload"/>-->
			<app-button class="ml-auto block mt-5" @click="getLists">Upload another</app-button>
		</app-panel>

		<!-- Upload Tabs -->
		<tabs v-else :nav="nav" justify lazy-load>
			<template #tab1>
				<mail-list-manager :lists="lists" @uploaded="(summary) => (upload = summary)" />
			</template>

			<template #tab2>
				<mail-list-manager
					:lists="lists"
					update
					@uploaded="(summary) => (upload = summary)" />
			</template>
		</tabs>
	</div>

	<slideover title="Mailchimp Help" :open="help" @close="help = false">
		<mailchimp-help />
	</slideover>
</template>

<script lang="ts" setup>
	import Tabs, { type Tab } from '@/components/partials/Tabs.vue'
	import { onMounted, ref } from 'vue'
	import MailListManager from '@/components/partials/marketing/MailListManager.vue'
	import MailchimpService from '@/services/mailchimp'
	import useToaster from '@/stores/toaster'
	import MailchimpHelp from '@/components/partials/marketing/MailchimpHelp.vue'
	// import ListUploadSummary from '@/components/partials/marketing/ListUploadSummary.vue'

	const api = new MailchimpService()
	const toaster = useToaster()
	const lists = ref(null)
	const upload = ref()

	const help = ref(false)
	const nav = ref<Tab[]>([
		{
			name: 'Insert',
			id: '#insert',
			icon: ['fas', 'fa-file-circle-plus'],
			iconClasses: 'text-lg my-3',
			inline: true
		},
		{
			name: 'Update',
			id: '#update',
			icon: ['fas', 'fa-file-pen'],
			iconClasses: 'text-lg my-3',
			inline: true,
			disabled: true
		}
	])

	function getLists() {
		upload.value = null

		api.getLists()
			.then((response) => {
				lists.value = response.data

				if (lists.value.length > 0) {
					nav.value[1].disabled = false
				}
			})
			.catch((error) => {
				console.error(error)
				toaster.error({
					text: 'Error occurred obtaining mail lists'
				})
			})
	}

	onMounted(() => {
		getLists()
	})
</script>
